"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { drawerVariants } from "./Drawer.variants.js";
const { backdrop: backdrop } = drawerVariants();
const DrawerBackdrop_DrawerBackdrop = /*#__PURE__*/ forwardRef(function({ className, slots, ...props }, ref) {
    return /*#__PURE__*/ jsx(Drawer.Backdrop, {
        ref: ref,
        className: cn(backdrop(), className, slots?.backdrop),
        ...props
    });
});
export { DrawerBackdrop_DrawerBackdrop as DrawerBackdrop };
